<div lass="w-full p-8 bg-zinc-100 flex-col justify-start items-start gap-2.5 inline-flex">
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  <div class="self-stretch h-full flex-col justify-start items-start gap-[60px] flex">
    <div class="self-stretch rounded-lg bg-white shadow-sm p-6">
      <div class="bg-white shadow-sm-light">

        <app-info-appel [base]="'applicationOffTrack'" [cohorte]="cohorte"></app-info-appel>
        <div class="border-b border-gray-200 dark:border-gray-700">
          <ul class="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400">
            <li class="me-2">
              <a [routerLink]="['/dashboard/appels/candidaturesHS/'+cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group">
                <svg class="w-6 h-6 text-gray-800 dark:text-white mr-2" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                    d="M8 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h2a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2Zm6 1h-4v2H9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2h-1V4Zm-6 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z"
                    clip-rule="evenodd" />
                </svg>

                Candidatures
              </a>
            </li>
            <li class="me-2">
              <a [routerLink]="['/dashboard/appels/admisHS/'+cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group">
                <svg class="w-6 h-6 text-gray-800 dark:text-white mr-2" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                    d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l4-4Z"
                    clip-rule="evenodd" />
                </svg>

                Admis
              </a>
            </li>
            <li class="me-2">
              <a [routerLink]="['/dashboard/appels/statistiquesHS/'+cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group">
                <svg class="w-6 h-6 text-blue-600 dark:text-white mr-2" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M4 4v15a1 1 0 0 0 1 1h15M8 16l2.5-5.5 3 3L17.273 7 20 9.667" />
                </svg>
                Statistiques
              </a>
            </li>
            <li class="me-2">
              <a [routerLink]="['/dashboard/appels/statconnectionHP/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center whitespace-nowrap p-4 text-gray-600 border-b-2 hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300">
                <svg class="w-2 h-6 text-gray-600 dark:text-white mr-2 shrink-0" id="icon" viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M30,30H22V4h8Zm-6-2h4V6H24Z"></path>
                  <path d="M20,30H12V12h8Z"></path>
                  <path d="M10,30H2V18h8Z"></path>
                  <rect data-name="<Transparent Rectangle>" id="_Transparent_Rectangle_"></rect>
                </svg>

                Statistiques de connexion
              </a>
            </li>
          </ul>
        </div>
        <div class="w-full p-1 bg-white delib-screen admis flex-col justify-start items-start gap-2.5 inline-flex">
          <div class="w-full p-8 bg-white flex-col justify-start items-start gap-2.5 inline-flex">
            <div class="self-stretch h-full flex-col justify-start items-start gap-2 flex">
              <!-- <div class="self-stretch flex-col justify-start items-start gap-6 flex">
                <div class="self-stretch h-[66px] flex-col justify-start items-start gap-1 flex">
                  <div class="self-stretch title-ctnr justify-start items-start gap-4 inline-flex">
                    <div class="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex">
                      <div class="self-stretch text-center text-gray-900 text-3xl font-semibold mt-5">
                        Statistiques
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="self-stretch flex-col justify-start items-center gap-6 flex">
                <div class="w-full p-1 justify-start items-start gap-6 flex flex-col">

                  <div class="w-full flex tab-ctnr">
                    <canvas id="canvasCityAndGender" class="chart-canvas w-full" height="300"></canvas>
                  </div>

                  <div class="w-full flex tarte-ctnr">
                    <canvas id="canvasFamily" class="chart-canvas w-full" height="300"></canvas>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>